/**
 * @fileoverview Default Searches landing.
 *
 * InfoTrack is gated to Morgan users (super_admin), so the default tab
 * depends on the role: super_admins land on InfoTrack, everyone else on
 * the broadly-available Web search tab.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import { useEffect } from "react";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/",
)({
  component: SearchesIndexRedirect,
});

function SearchesIndexRedirect() {
  const { jobId } = Route.useParams();
  const navigate = useNavigate();
  const { data: user, isLoading } = useQuery(
    convexQuery(api.users.queries.getCurrentUser, {}),
  );

  useEffect(() => {
    if (isLoading || !user) return;
    navigate({
      to:
        user.systemRole === "super_admin"
          ? "/dashboard/jobs/$jobId/searches/infotrack"
          : "/dashboard/jobs/$jobId/searches/web",
      params: { jobId },
      replace: true,
    });
  }, [isLoading, user, navigate, jobId]);

  return null;
}
